import classNames from 'classnames'

import './Badge.scss'

export type Variant =
  | 'success'
  | 'warning'
  | 'danger'
  | 'primary'
  | 'white'
  | 'info'

interface BadgeProps {
  value?: string | string[]
  variant?: Variant
}

export const Badge: React.FC<BadgeProps> = ({ value, variant = 'primary' }) => {
  if (!value || !value.length) return

  if (Array.isArray(value)) {
    return (
      <div className="badge-array-wrapper">
        {value.map((el) => (
          <div key={el} className={classNames('badge-wrapper', variant)}>
            <div className="badge-content">{el}</div>
          </div>
        ))}
      </div>
    )
  }

  return (
    <div className={classNames('badge-wrapper', variant)}>
      <div className="badge-content">{value}</div>
    </div>
  )
}
